import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { KNOWLEDGE_BASE_READ_PERMISSION } from "../permissions";

const KnowledgeBaseAccessControl = ({
    children,
    baseResources = KNOWLEDGE_BASE_READ_PERMISSION,
}) => (
    <ComponentAccessControl baseResources={baseResources}>
        {children}
    </ComponentAccessControl>
);

export default KnowledgeBaseAccessControl;
